var detecthttp = window.location.protocol;
var StoreURL =
  detecthttp + "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2";
var isEU = false;
var isProAdvanced = false;
var selected_model_type = "";
var selected_country_code = "";
var selected_formula_brand = "";
var salesforce_url = "https://knowledge.babybrezza.com/s/formula-settings?";
var hasCamera = false;

var detected_upcs = [];

Quagga.onDetected(function (result) {
  if (detected_upcs.includes(result.codeResult.code)) {
    detected_upcs = [];
    // Handle the detected barcode here
    $("#upc_input").val(result.codeResult.code);
    $("#upc_enter").get(0).click();
    Quagga.stop();
    $("#interactive").hide();
  } else {
    detected_upcs.push(result.codeResult.code);
  }
});

const scrollToID = (id) => {
  $("html, body").animate(
    {
      scrollTop: $(id).offset().top - 85,
    },
    250,
    "swing"
  );
};

$(document).ready(function () {
  $.ajaxSetup({ cache: false }); // or iPhones don't get fresh data
  GetTerritoryData(StoreURL);

  $("#tool_filter .additional-info-btn").click(() => {
    scrollToID("#additional_info_mobile");
  });

  $("#upc_enter").on("keypress click", function (e) {
    if (!checkEmailSubmit()) {
      $("#sel_type").prop("selectedIndex", 0);
      var targetElement = $("#enter_email_input");
      targetElement.focus();
      return;
    }

    if (e.which === 13 || e.type === "click") {
      e.preventDefault();

      let upc = $("#upc_input").val();

      upc = String(upc).trim();

      if (upc) {
        upc = upc.replace(/[^a-z0-9]/gi, "");
        findByUpc(upc);
      }
    }
  });

  $("#start_upc, #upc_start").on("keypress click", function (e) {
    if (!checkEmailSubmit()) {
      $("#sel_type").prop("selectedIndex", 0);
      var targetElement = $("#enter_email_input");
      targetElement.focus();
      return;
    }

    if (e.which === 13 || e.type === "click") {
      e.preventDefault();

      navigator.mediaDevices
        .enumerateDevices()
        .then(function (devices) {
          hasCamera = devices.some(function (device) {
            return device.kind === "videoinput";
          });
          if (hasCamera) {
            $("#result").html("");
            Quagga.init(
              {
                inputStream: {
                  name: "Live",
                  type: "LiveStream",
                  target: document.querySelector("#interactive"),
                  constraints: {
                    facingMode: "environment", // or "user" for front camera
                  },
                },
                decoder: {
                  readers: ["upc_reader", "ean_reader"], // or other supported barcode types
                },
                locator: {
                  patchSize: 5,
                  halfSample: false,
                },
                numOfWorkers: navigator.hardwareConcurrency || 1,
                frequency: 20,
                locate: true,
              },
              function (err) {
                if (err) {
                  console.error(err);
                  return;
                }
                console.log("Initialization finished. Ready to start");
                Quagga.start();
                $("#interactive").show();

                Quagga.onProcessed(function (result) {
                  var drawingCtx = Quagga.canvas.ctx.overlay;
                  var drawingCanvas = Quagga.canvas.dom.overlay;

                  drawingCtx.clearRect(
                    0,
                    0,
                    parseInt(drawingCanvas.getAttribute("width")),
                    parseInt(drawingCanvas.getAttribute("height"))
                  );

                  // if (result && result.boxes) {
                  //   drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
                  //   result.boxes.filter(function(box) {
                  //     return box !== result.box;
                  //   }).forEach(function(box) {
                  //     drawingCtx.strokeStyle = "#00FF00";
                  //     drawingCtx.lineWidth = 2;
                  //     drawingCtx.strokeRect(box.x, box.y, box.width, box.height);
                  //   });
                  // }

                  if (result && result.box) {
                    Quagga.ImageDebug.drawPath(
                      result.box,
                      { x: 0, y: 1 },
                      drawingCtx,
                      { color: "#00F", lineWidth: 2 }
                    );
                  }

                  if (result && result.codeResult && result.codeResult.code) {
                    // Barcode detected, do further processing here
                    console.log("Barcode detected: " + result.codeResult.code);
                  }
                });
              }
            );
          } else {
            $("#result").html(
              '<p style="font-size: 16px; font-weight: 700; text-transform: uppercase; margin:0; color: red;">No se detectó ninguna cámara<p>'
            );
          }
        })
        .catch(function (err) {
          // An error occurred while accessing media devices
          console.error("Error accessing media devices:", err);
        });
    }
  });
});

function checkEmailSubmit() {
  // Get the input value
  var emailInput = document.getElementById("enter_email_input");

  if (!emailInput) {
    return true;
  }

  var email = emailInput.value;

  // Regular expression for email validation
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Check if the email matches the regular expression
  if (emailRegex.test(email)) {
    $("#invalid_email").hide();
    $("#enter_email_input").removeClass("invalid");
    return true;
  } else {
    $("#invalid_email").show();
    $("#enter_email_input").addClass("invalid");
    return false;
  }
}
function findByUpc(upc) {
  UPC_URL =
    detecthttp +
    "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getupc";
  // var datas = "upc=" + upc + "&language=es";

  var ip_address = getUserCookie("ip_address");
  var state_prov = getUserCookie("state_prov");
  var zip = getUserCookie("zip");
  var country = getUserCookie("country");
  var city = getUserCookie("city");
  var user_agent = navigator.userAgent;
  var babyb_store = "babybrezza.es";
  var touch_device = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  var datas =
    "upc=" +
    upc +
    "&language=es" +
    "&email=" +
    $("#enter_email_input").val() +
    "&ip_address=" +
    ip_address +
    "&user_agent=" +
    user_agent +
    "&touch_device=" +
    touch_device +
    "&state_prov=" +
    state_prov +
    "&zip=" +
    zip +
    "&country=" +
    country +
    "&city=" +
    city +
    "&babyb_store=" +
    babyb_store;

  $("#upc_results").show();
  $("#sel_territory").prop("selectedIndex", 0);
  $("#sel_brand").html(
    '<option value="">-- Elija su marca de fórmula --</option>'
  );
  $("#sel_brand").prop("selectedIndex", 0);
  $("#sel_type").html(
    '<option value="">-- Elija su fórmula Etapa/rango de edad --</option>'
  );
  $("#sel_type").prop("selectedIndex", 0);

  $("#upc_settings").show();

  crossDomainAjax(UPC_URL, datas, function (data) {
    console.log(data);
    if (data == "no-upc") {
      $("#upc_settings").html(
        '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px;"><strong>No se encontraron resultados para código de barras:</strong> ' +
          upc +
          "<br>Seleccione la marca/tipo de fórmula arriba</h2>"
      );
      $("#find_stage_setting").html("");
      $("#formula_pro_filter .Formula_sign_up_con").hide();
    } else {
      $("#upc_settings").html(
        '<h2 style="text-transform: none; margin-top: 20px; margin-bottom: 15px; font-size: 20px;"><strong>Resultados para código de barras:</strong> ' +
          upc +
          "</h2>"
      );
      $("#find_stage_setting").html(data);
      $("#formula_pro_filter .Formula_sign_up_con").show();
      scrollToID("#formula_pro_filter .Formula_sign_up_con");
    }
  });
}
function proc(model_type) {
  $("#choose_brand_link").hide();
  $("#choose_stage_link").hide();

  if (model_type == "advanced") {
    selected_model_type = "Formula Pro Advanced";
    jQuery("#add_adv").addClass("active");
    jQuery("#add_adv_wifi, #add_pro_mini").removeClass("active");

    isProAdvanced = false;
    $("#contactFormProduct option[value='553111519266']").prop(
      "selected",
      true
    );
  } else if (model_type == "advanced_wifi") {
    selected_model_type = "Formula Pro Advanced WiFi";
    jQuery("#add_adv_wifi").addClass("active");
    jQuery("#add_adv, #add_pro_mini").removeClass("active");
    isProAdvanced = true;
    $("#contactFormProduct option[value='4390264078370']").prop(
      "selected",
      true
    );
  } else if (model_type == "pro_mini") {
    selected_model_type = "Formula Pro Mini";
    jQuery("#add_pro_mini").addClass("active");
    jQuery("#add_adv, #add_adv_wifi").removeClass("active");
    isProAdvanced = false;
    $("#contactFormProduct option[value='7084746244276']").prop(
      "selected",
      true
    );
  }

  $("#productSelectionDiv").hide();
  $("#warranty_regi_div").show();

  //$("#tool_filter").show();

  jQuery("#model_type").val("advanced");

  var StoreURL =
    detecthttp + "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2";
  GetTerritoryData(StoreURL);
  scrollToID("#formula_pro_filter");
}

function GetTerritoryData(StoreURL) {
  var model_type = $("#model_type").val();
  var datas = "model_type=" + model_type + "&language=es";

  $("#sel_brand").html(
    '<option value="">-- Elija su marca de fórmula --</option>'
  );
  $("#sel_brand").prop("selectedIndex", 0);

  $("#sel_type").html(
    '<option value="">-- Elija su fórmula Etapa/rango de edad --</option>'
  );
  $("#sel_type").prop("selectedIndex", 0);

  $("#find_stage_setting").html("");

  console.log(datas);

  crossDomainAjax(StoreURL, datas, function (data) {
    $("#sel_territory").html(data);
  });
}

function getbrand(val) {
  if (!checkEmailSubmit()) {
    $("#sel_territory").prop("selectedIndex", 0);
    var targetElement = $("#enter_email_input");
    targetElement.focus();
    return;
  }

  selected_country_code = val;
  $("#choose_brand_link").css("display", "inline-block");
  $("#choose_stage_link").hide();

  $("#missing_brand").attr(
    "href",
    salesforce_url +
      "product=" +
      selected_model_type +
      "&country=" +
      selected_country_code
  );

  if (val === "European%20Union") {
    isEU = true;
  } else {
    isEU = false;
  }

  var model_type = $("#model_type").val();
  var datas =
    "territory_id=" + val + "&model_type=" + model_type + "&language=es";

  if (isEU && isProAdvanced) {
    var BRAND_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getbrand"; // temporarily disabling scoop weight search: _eu_advanced';
  } else {
    var BRAND_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getbrand";
  }

  // hidden field set territory id
  $("#sel_territory_id").val("");
  $("#sel_brand_id").val("");
  $("#sel_type_id").val("");
  $("#sel_territory_id").val(val);

  $(
    "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
  ).hide();
  if (val == "United%20States%20of%20America") {
    $(
      "#us_store_brnd_description, #us_store_brnd_description_mobile, #formula_brand_tooltip"
    ).show();
  }
  $("#choose_type").show();
  $("#sel_type").html(
    '<option value="">-- Elija su fórmula Etapa/rango de edad --</option>'
  );
  $("#sel_type").prop("selectedIndex", 0);

  $("#find_stage_setting").html("");

  crossDomainAjax(BRAND_URL, datas, function (data) {
    $("#sel_brand").html(data);
  });
}

function gettypepro(val) {
  if (!checkEmailSubmit()) {
    $("#sel_brand").prop("selectedIndex", 0);
    var targetElement = $("#enter_email_input");
    targetElement.focus();
    return;
  }

  selected_formula_brand = val;
  $("#choose_stage_link").css("display", "inline-block");
  $("#missing_stage").attr(
    "href",
    salesforce_url +
      "product=" +
      selected_model_type +
      "&country=" +
      selected_country_code +
      "&formula_name=" +
      selected_formula_brand
  );

  // hidden field set brand id
  $("#sel_brand_id").val("");
  $("#sel_type_id").val("");
  $("#sel_brand_id").val(val);

  var territory_id = $("#sel_territory_id").val();
  var model_type = $("#model_type").val();
  var datas =
    "brand_id=" +
    val +
    "&territory_id=" +
    territory_id +
    "&model_type=" +
    model_type +
    "&language=es";

  if (isEU && isProAdvanced) {
    var TYPEPRO_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/gettypepro"; // temporarily disabling scoop weight search: _eu_advanced';
  } else {
    var TYPEPRO_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/gettypepro";
  }

  $("#choose_type").show();
  $("#find_stage_setting").html("");

  crossDomainAjax(TYPEPRO_URL, datas, function (data) {
    $("#sel_type").html(data);
    if (
      data != undefined &&
      data != "" &&
      data !=
        '<option value="">-- Choose Your Formula Stage/Age Range --</option>'
    ) {
      $("#sel_type").html(data);
      setTimeout(function () {
        $("#sel_type option:eq(1)").change();
      }, 600);
    } else {
      var datas =
        "brand_id=" +
        val +
        "&territory_id=" +
        territory_id +
        "&model_type=" +
        model_type +
        "&language=es";
      if (isEU && isProAdvanced) {
        var TYPEPRO_URL =
          detecthttp +
          "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getbrandtosetting"; // temporarily disabling scoop weight search: _eu_advanced';
      } else {
        var TYPEPRO_URL =
          detecthttp +
          "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getbrandtosetting";
      }

      crossDomainAjax(TYPEPRO_URL, datas, function (data) {
        if (data != undefined && data != "") {
          $("#choose_type").hide();
          $("#find_stage_setting").html(data);
        } else {
          console.error("Stage and Setting not found type and brand...");
        }
      });
    }
  });
}
var glob_val;
function getstagesettign(val) {
  if (!checkEmailSubmit()) {
    $("#sel_type").prop("selectedIndex", 0);
    var targetElement = $("#enter_email_input");
    targetElement.focus();
    return;
  }

  $("#upc_settings").hide();
  $("#upc_input").val("");

  glob_val = val;

  // hidden field set type id
  $("#sel_type_id").val("");
  $("#sel_type_id").val(val);

  var territory_id = $("#sel_territory_id").val();
  var brand_id = $("#sel_brand_id").val();
  var model_type = $("#model_type").val();
  // var datas =
  //   "type_id=" +
  //   val +
  //   "&territory_id=" +
  //   territory_id +
  //   "&brand_id=" +
  //   brand_id +
  //   "&model_type=" +
  //   model_type;
  var email = $("#enter_email_input").val();
  var ip_address = getUserCookie("ip_address");
  var state_prov = getUserCookie("state_prov");
  var zip = getUserCookie("zip");
  var country = getUserCookie("country");
  var city = getUserCookie("city");
  var user_agent = navigator.userAgent;
  var touch_device = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  var babyb_store = "babybrezza.es";
  var datas =
    "type_id=" +
    val +
    "&territory_id=" +
    territory_id +
    "&brand_id=" +
    brand_id +
    "&model_type=" +
    model_type +
    "&email=" +
    email +
    "&ip_address=" +
    ip_address +
    "&user_agent=" +
    user_agent +
    "&touch_device=" +
    touch_device +
    "&state_prov=" +
    state_prov +
    "&zip=" +
    zip +
    "&country=" +
    country +
    "&city=" +
    city +
    "&babyb_store=" +
    babyb_store;

  if (isEU && isProAdvanced) {
    var SETTING_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getsetting"; // temporarily disabling scoop weight search: _eu_advanced';
  } else {
    var SETTING_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getsetting";
  }

  $("#find_stage_setting").html("");
  crossDomainAjax(SETTING_URL, datas, function (data) {
    var country_code = getCookie("country");
    if (country_code == "US") {
      if (data != undefined && data != "") {
        $(".Formula_sign_up_con").show();
        getData();
      } else {
        console.error("Stage and Setting not found type and brand...");
      }
    } else {
      if (data != undefined && data != "") {
        $(".Formula_sign_up_con").show();
        getData();
      } else {
        console.error("Stage and Setting not found type and brand...");
      }
    }

    //$("#find_stage_setting").html("<div class='wrapper'><p><b>Step 4:</b> Obtain your formula settings.</p></div>" + data);
  });
}

function getData() {
  var territory_id = $("#sel_territory_id").val();
  var brand_id = $("#sel_brand_id").val();
  var model_type = $("#model_type").val();

  if (isEU && isProAdvanced) {
    // console.log('EU and Advanced again again!!!');
    var SETTING_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getsetting"; // temporarily disabling scoop weight search: _eu_advanced';
  } else {
    var SETTING_URL =
      detecthttp +
      "//babybrezzaserver.com/index.php/filterproduct_aws_upc_2/getsetting";
  }

  var datas =
    "type_id=" +
    glob_val +
    "&territory_id=" +
    territory_id +
    "&brand_id=" +
    brand_id +
    "&model_type=" +
    model_type +
    "&language=es";

  crossDomainAjax(SETTING_URL, datas, function (data) {
    // console.log('submit');
    //$('.klaviyo-form').fadeOut();
    var country_code = getCookie("country");
    if (country_code == "US")
      $("#find_stage_setting").html("<div class='wrapper'>" + data + "</div>");
    else
      $("#find_stage_setting").html("<div class='wrapper'>" + data + "</div>");
    $("#enjoy-msg, #fps-mail-cta, #more-products-wrapper").show();

    $(".more-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      focusOnSelect: true,
      draggable: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4,
          },
        },
      ],
    });

    $(window).on("resize orientationchange", function () {
      $(".more-slider").slick("resize");
    });

    if (country_code == "US") $("#shop-cross-wrapper").show();
  });

  scrollToID("#formula_pro_filter .Formula_sign_up_con");
}

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == "submit") {
    getData();
  }
});

var skipBtn = document.querySelector(".fpa_skip");
// console.log('skipBtn: ', skipBtn);
if (skipBtn) {
  skipBtn.addEventListener("click", function (e) {
    e.preventDefault();
    getData();
  });
}

function crossDomainAjax(url, querystring, successCallback) {
  //$('#search_loader_new').show();
  // console.log('url: ', url, 'query: ', querystring)

  if ("XDomainRequest" in window && window.XDomainRequest !== null) {
    var str;
    str = "";
    str = decodeURI(querystring);
    url = url + "?" + str;
    var xdr = new XDomainRequest(); // Use Microsoft XDR
    xdr.open("POST", url);

    xdr.onload = function () {
      successCallback(xdr.responseText); // internal function
    };

    xdr.onerror = function () {
      console.error("ajax error");
      _result = false;
    };

    setTimeout(function () {
      xdr.send();
    }, 1000);
  } else if (
    navigator.userAgent.indexOf("MSIE") != -1 &&
    parseInt(navigator.userAgent.match(/MSIE ([\d.]+)/)[1], 10) < 8
  ) {
    return false;
  } else {
    $.ajax({
      url: url,
      cache: false,
      //timeout: 4000,
      type: "POST",
      data: querystring,
      async: false, // must be set to false
      success: function (data, success) {
        successCallback(data);
      },
    });
  }
}

function getUserCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
